import { useAuth0 } from '@auth0/auth0-react';

export const Forbidden = () => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = () => {
    loginWithRedirect({
      appState: {
        prompt: 'login',
      },
    });
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
        Forbidden
      </h1>
      <p className="mt-5 text-base leading-7 text-gray-600">
        Sorry, you need to authenticate to access this page.
      </p>
      <div className="mt-10 flex items-center justify-center gap-x-6">
        <button type="button" onClick={handleLogin}>
          Click here to login
        </button>
      </div>
    </div>
  );
};
